module.exports = __webpack_public_path__ + "static/media/floor-plan-dark.3cc5f2a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/floor-plan-dark.svg
// module id = 2382
// module chunks = 0